module.exports = __webpack_public_path__ + "img/image-2.9d3903a9.jpg";